/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {UntypedFormArray, UntypedFormGroup} from '@angular/forms';

export class FormUtils {

  static markAllAsTouched(form: any) {
    // form.markAllAsTouched();
    Object.keys(form.controls).forEach(key => {
      if (form.controls[key] instanceof UntypedFormGroup || form.controls[key] instanceof UntypedFormArray) {
        this.markAllAsTouched(form.controls[key]);
      }
      form.controls[key].markAsTouched();
    });
  }

  static markAllAsDirty(form: any) {
    Object.keys(form.controls).forEach(key => {
      if (form.controls[key] instanceof UntypedFormGroup || form.controls[key] instanceof UntypedFormArray) {
        this.markAllAsDirty(form.controls[key]);
      }
      form.controls[key].markAsDirty();
    });
  }

  static clearOrInitializeFormArray(formArray: UntypedFormArray) {
    if (formArray === null) {
      formArray = new UntypedFormArray([]);
    }
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

  static scrollTo(el: Element) {
    if (el) {
      el.scrollIntoView({block: 'start', behavior: 'smooth'});
    }
  }

  static scrollToError(): void {
    const firstElementWithError = document?.querySelector('.ng-invalid');
    this.scrollTo(firstElementWithError);
  }

  static scrollTop() {
    window.scrollTo(0, 0);
  }

  static removeEmpty(obj: any) {
    Object.keys(obj).forEach(key => {
      if (obj[key] && typeof obj[key] === 'object') {
        this.removeEmpty(obj[key]);
      } else if (obj[key] == null) {
        delete obj[key];
      }
    });
  }
}
